module.exports = __webpack_public_path__ + "img/unselec-f2f.02c01725.svg";